import { render, staticRenderFns } from "./openInventoryAction.vue?vue&type=template&id=1cb31496&scoped=true"
import script from "./openInventoryAction.vue?vue&type=script&lang=js"
export * from "./openInventoryAction.vue?vue&type=script&lang=js"
import style0 from "./openInventoryAction.vue?vue&type=style&index=0&id=1cb31496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb31496",
  null
  
)

export default component.exports